import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent, LoggerService } from '@tytapp/common';
import { UserService } from '../user.service';

@Component({
    selector: 'tyt-assume-user',
    templateUrl: './assume.component.html',
    styleUrls: ['./assume.component.scss'],
    standalone: false
})
export class AssumeComponent extends BaseComponent implements OnInit {
    private userService = inject(UserService);
    private route = inject(ActivatedRoute);

    logger = inject(LoggerService).configure({ source: 'assume' });

    errorMessage: string = null;

    async init() {
        this.route.paramMap.subscribe(params => {
            let token = params.get('token');
            this.assumeUser(token);
        });
    }

    async assumeUser(token: string) {
        try {
            await this.userService.assume(token);
        } catch (e) {
            if (e.status == 401) {
                alert(`Invalid authentication token!`);
            } else {
                this.logger.error(e.message || e.error, e);
                this.errorMessage = `An error occurred while attempting to assume the user: ${e.message || e.error}`;
            }
            return;
        }

        this.redirection.go('/settings/memberships');
        if (typeof window !== 'undefined') {
            this.shell.alert('Success', `You have switched to <strong>${this.userService.user.email}</strong>`);
        }
    }

}
